import { Button, Col, Row } from 'antd';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSearchOptions from './usePatientSearchOptions';

function Filter({ onChange, initFilters, forceSearch }) {
  const { t } = useTranslation('Vindoc');
  const [params, setParams] = useState(initFilters);

  const handleOnChangeFilter = (p, type, values, triggerSearch = false) => {
    if (!type) return;
    let tempFilterData = {};

    switch (type) {
      default:
        tempFilterData = {
          ...p,
          [type]: values,
        };
        break;
    }
    setIsFiltered(true);
    if (triggerSearch) {
      onSearch(tempFilterData);
    } else {
      onChangeParams(tempFilterData);
    }
  };

  const SEARCH_OPTIONS = useSearchOptions(params, handleOnChangeFilter);

  const INITIAL_SEARCH_FIELDS = [0, 1, 2, 3];

  const [searchFields, setSearchFields] = useState([...INITIAL_SEARCH_FIELDS]);
  const [isFiltered, setIsFiltered] = useState(false);

  const onChangeParams = (p) => {
    setParams(p);
  };

  const onSearch = (p) => {
    setParams(p);
    onChange(p);
  };

  // const handleOnSearch = () => {
  //   setIsFiltered(true);
  //   onSearch({ ...params });
  // };

  /*   const handleChangeSearchKey = (key, replacekey) => {
    let tempParams = { ...params };
    delete tempParams[key];
    setIsFiltered(true);
    onChangeParams(tempParams);

    let tempSearchField = [...searchFields];
    const currentItemIndex = SEARCH_OPTIONS.findIndex((it) => it.key == key);
    const replaceItemIndex = SEARCH_OPTIONS.findIndex((it) => it.key == replacekey);
    tempSearchField = tempSearchField.map((it) => (it == currentItemIndex ? replaceItemIndex : it));
    setSearchFields(tempSearchField);
  }; */

  const handleClearAllFilters = () => {
    setSearchFields(INITIAL_SEARCH_FIELDS);
    setParams({ ...initFilters });
    onChange({ ...initFilters });
    setIsFiltered(false);
  };

  return (
    <div className="flex w-full flex-wrap items-end space-x-2 pb-2">
      <Row gutter={[8, 8]} align="bottom">
        {searchFields &&
          SEARCH_OPTIONS &&
          searchFields.map((idx) => {
            const field = SEARCH_OPTIONS[idx];
            /* const options = SEARCH_OPTIONS.filter(
                (_, i) => i == idx || !searchFields.includes(i)
              ); */
            const Component = field?.component;

            return (
              <Col key={field?.key} className="search-item mr-1">
                <div>{t(field?.text)}</div>
                <div>{Component ? Component : null}</div>
              </Col>
            );
          })}

        <div className="flex items-end">
          <Col>
            <Button
              type="primary"
              className="filter-btn"
              size="small"
              onClick={() => forceSearch?.(params)}
            >
              {t('Search')}
            </Button>
          </Col>
          <Col>
            <Button
              className="filter-btn"
              size="small"
              disabled={!isFiltered}
              onClick={() => handleClearAllFilters()}
            >
              {t('Clear Filter')}
            </Button>
          </Col>
        </div>
      </Row>
    </div>
  );
}

export default memo(Filter);
